

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import { getDate } from '../utils/getDate'
import { checkIfCheckPeriodIsLocked } from '../utils/checkIfCheckPeriodIsLocked'

type Props = {
    thisChecklistPeriod: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue
}

function FormatCheckPeriodStartedBy({
    thisChecklistPeriod,
    thisChecklist
}: Props) {

    const {
        userData,
        loggedIn,
        t
    } = useContext(GlobalContext)



    const isCheckPeriodLocked = thisChecklistPeriod && checkIfCheckPeriodIsLocked(thisChecklistPeriod, thisChecklist, userData, loggedIn)
    const checkPeriodStartedByUserDetails = thisChecklistPeriod && thisChecklistPeriod['startedByUserDetails'] || {}

    let userString = ``

    if (checkPeriodStartedByUserDetails['loginMethod'] === 'guest') {
        userString = ` ${t('Dashboard.FormatCheckPeriodStartedBy.guestUser')} `
    } else {
        userString = ` `
    }
    if (checkPeriodStartedByUserDetails['name']) {
        userString = `${userString} ${checkPeriodStartedByUserDetails['name']}`
    }
    if (checkPeriodStartedByUserDetails['email']) {
        userString = `${userString} (${checkPeriodStartedByUserDetails['email']})`
    }
    if (userString !== '') {
        userString = `${userString}`
    } else {
        userString = ` ${t('Dashboard.FormatCheckPeriodStartedBy.anotherUser')} `
    }

    if (!thisChecklistPeriod || !thisChecklist) {
        return null
    }

    return <div className={`flex flex-row items-center gap-2 text-sm`}>

        {isCheckPeriodLocked &&
            <>
                <p className={`text-xl`}>🔐</p>
                <p>{t('Dashboard.FormatCheckPeriodStartedBy.checklistLocked', { user: userString })}</p>
            </>}

        {!isCheckPeriodLocked
            && thisChecklistPeriod
            && thisChecklistPeriod['startedByUserDetails'] &&
            <p>{t('Dashboard.FormatCheckPeriodStartedBy.checklistStartedBy', { user: userString })}</p>}
    </div>
}

export default FormatCheckPeriodStartedBy